/***
 *
 *   VIEW TOGGLE
 *   Kanban / list segmented control. Ported from
 *   ui-reference/src/components/tickets/view-toggle.tsx.
 *
 *   PROPS
 *   viewMode: 'kanban' | 'list'
 *   onChange: (mode) => void
 *
 **********/

import { Button, Tooltip, cn } from 'components/lib';
import { useTranslate } from 'app/translations';

export function ViewToggle(props) {
    const { viewMode = 'kanban', onChange } = props;
    const { _t } = useTranslate();

    return (
        <div className="inline-flex h-9 shrink-0 items-center gap-0.5 rounded-md border bg-surface px-0.5">
            <Tooltip label={_t('ticket.views.kanban')} delayDuration={300}>
                <Button
                    variant="ghost"
                    size="sm"
                    icon="columns"
                    iconColor="currentColor"
                    action={() => onChange?.('kanban')}
                    ariaLabel={_t('ticket.views.kanban')}
                    title={_t('ticket.views.kanban')}
                    className={cn(
                        'h-8 w-8 p-0',
                        viewMode === 'kanban' &&
                            'bg-primary-100 text-primary-700 dark:bg-primary-900/50 dark:text-primary-200',
                    )}
                />
            </Tooltip>
            <Tooltip label={_t('ticket.views.list')} delayDuration={300}>
                <Button
                    variant="ghost"
                    size="sm"
                    icon="list"
                    iconColor="currentColor"
                    action={() => onChange?.('list')}
                    ariaLabel={_t('ticket.views.list')}
                    title={_t('ticket.views.list')}
                    className={cn(
                        'h-8 w-8 p-0',
                        viewMode === 'list' &&
                            'bg-primary-100 text-primary-700 dark:bg-primary-900/50 dark:text-primary-200',
                    )}
                />
            </Tooltip>
        </div>
    );
}
